import { render, staticRenderFns } from "./KanbanColumn.vue?vue&type=template&id=3dce3027&scoped=true&"
import script from "./KanbanColumn.vue?vue&type=script&lang=js&"
export * from "./KanbanColumn.vue?vue&type=script&lang=js&"
import style0 from "./KanbanColumn.vue?vue&type=style&index=0&id=3dce3027&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce3027",
  null
  
)

export default component.exports